export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-zerply-a2bcb700dadb60b3d6eca85d6743ada4.svg";